// ── The war-council table: the shared 3D table dressed as iron-banded oak,
//    with the campaign map etched into its leather. ──

import Table3D from '../arena/Table3D';

const SIGIL_COLOR = {
  Italy:   { ink: '#0b3d1a', sigil: '#0f9d58', glow: 'rgba(0,200,90,0.28)' },
  Spain:   { ink: '#4a0a06', sigil: '#e0b000', glow: 'rgba(255,170,0,0.28)' },
  France:  { ink: '#0a1240', sigil: '#7a9bff', glow: 'rgba(90,130,255,0.28)' },
  England: { ink: '#460309', sigil: '#ff6b78', glow: 'rgba(255,80,90,0.26)' },
  Unknown: { ink: '#3a2a08', sigil: '#ffd700', glow: 'rgba(251,191,36,0.26)' },
};

// Faint campaign map etched into the table leather
const BattleMap = ({ tone }) => (
  <svg viewBox="0 0 400 260" preserveAspectRatio="none" style={{ width: '100%', height: '100%', opacity: 0.5 }}>
    {[0, 1, 2, 3, 4].map(i => (
      <path key={i}
        d={`M-10 ${40 + i * 44} q60 ${-18 - i * 3} 120 4 q70 26 150 -10 q80 -34 150 6`}
        fill="none" stroke={tone} strokeWidth="0.8" opacity={0.35 - i * 0.04} />
    ))}
    <path d="M20 250 q40 -70 20 -110 q-16 -46 34 -82 q40 -30 90 -24" fill="none" stroke={tone} strokeWidth="2.4" opacity="0.28" />
    <path d="M60 210 L140 160 L210 172 L280 120 L350 96" fill="none" stroke={tone} strokeWidth="1.4" strokeDasharray="7 6" opacity="0.5" />
    {[[140, 160], [280, 120], [350, 96]].map(([x, y], i) => (
      <g key={i} opacity="0.55">
        <path d={`M${x - 6} ${y - 6} L${x + 6} ${y + 6} M${x + 6} ${y - 6} L${x - 6} ${y + 6}`} stroke={tone} strokeWidth="1.6" />
      </g>
    ))}
    <g transform="translate(340 210)" opacity="0.5">
      <circle r="20" fill="none" stroke={tone} strokeWidth="1" />
      <circle r="13" fill="none" stroke={tone} strokeWidth="0.6" />
      <path d="M0 -22 L5 0 L0 22 L-5 0 Z" fill={tone} opacity="0.7" />
      <path d="M-22 0 L0 -5 L22 0 L0 5 Z" fill={tone} opacity="0.4" />
    </g>
  </svg>
);

const WarTable = ({ children, kingdom = 'Unknown', mobile = false, active = false }) => {
  const c = SIGIL_COLOR[kingdom] || SIGIL_COLOR.Unknown;
  return (
    <Table3D
      mobile={mobile}
      active={active}
      surface={{ top: '#2a1c0e', mid: '#1a1006', low: '#241708', deep: '#140b04' }}
      trim={{ rim: 'rgba(120,100,66,0.85)', rivet: '#b9a377', ink: c.ink, accent: c.sigil, glow: c.glow }}
      inlay={<BattleMap tone={c.sigil} />}
    >
      {children}
    </Table3D>
  );
};

export default WarTable;
